var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserLarge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M351.998 320H160.002C71.639 320 0 391.633 0 480C0 497.672 14.33 512 31.998 512H480.002C497.67 512 512 497.672 512 480C512 391.633 440.367 320 351.998 320ZM480.002 496H31.998C23.178 496 16 488.822 16 480C16 400.598 80.6 336 160.002 336H351.998C431.402 336 496 400.598 496 480C496 488.822 488.824 496 480.002 496ZM256 288C335.533 288 400 223.527 400 144S335.533 0 256 0C176.477 0 112 64.473 112 144S176.477 288 256 288ZM256 16C326.58 16 384 73.42 384 144C384 214.578 326.58 272 256 272C185.422 272 128 214.578 128 144C128 73.42 185.422 16 256 16Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLarge);
export default __webpack_public_path__ + "static/media/user-large.6ebc14cd1fa0601a56e0e44ae8ac6d61.svg";
export { ForwardRef as ReactComponent };